import Box from "@mui/material/Box"
import IconButton from "@mui/material/IconButton"
import ListItemIcon from "@mui/material/ListItemIcon"
import Menu from "@mui/material/Menu"
import MenuItem from "@mui/material/MenuItem"
import Typography from "@mui/material/Typography"
import i18n from "i18next"
import { useEffect, useState } from "react"

export interface LangSelectorProps { }

export default function UILangSelector({ }: LangSelectorProps): JSX.Element {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)
  const [currentLang, setCurrentLang] = useState("en")

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const changeLang = (lang: string) => {
    handleClose()
    i18n.changeLanguage(lang, () => {
      setCurrentLang(i18n.language)
    })
  }

  useEffect(() => {
    setCurrentLang(i18n.language)
  }, [])

  return (
    <>
      <IconButton
        size="large"
        edge="start"
        color="inherit"
        sx={{ marginLeft: 2, pointerEvents: "auto" }}
        onClick={handleClick}
      >
        <Box
          component="img"
          src={`./img/flags/${currentLang.split("-")[0]}.svg`}
          alt={i18n.language}
          sx={styles.flag}
          onError={(e) => e.currentTarget.src = "./img/flags/fr.svg"}
        />
      </IconButton>

      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
        sx={{ pointerEvents: "auto" }}
      >
        {[
          { id: "en", name: "English" },
          { id: "fr", name: "Français" },
          { id: "es", name: "Español" },
          { id: "de", name: "Deutsch" },
          { id: "it", name: "Italiano" },
          { id: "nl", name: "Nederlands" },
          { id: "fi", name: "Suomalainen" },
          { id: "sl", name: "Slovenščina" },
          { id: "sv", name: "Svenska" },
          { id: "zh", name: "中国人" },
        ].map((lang) => {
          return (
            <MenuItem
              onClick={() => {
                changeLang(lang.id)
              }}
              key={lang.id}
            >
              <ListItemIcon>
                <Box
                  component="img"
                  src={`./img/flags/${lang.id}.svg`}
                  alt={lang.name}
                  sx={styles.flag}
                />
              </ListItemIcon>
              <Typography>{lang.name}</Typography>
            </MenuItem>
          )
        })}
      </Menu>
    </>
  )
}

const styles = {
  flag: {
    width: "1.1rem",
    border: "2px solid white",
    borderRadius: "10rem",
    padding: "1px",
  },
}
